import { render, staticRenderFns } from "./MedicalNotesCategory.vue?vue&type=template&id=644197e7"
import script from "./MedicalNotesCategory.vue?vue&type=script&lang=js"
export * from "./MedicalNotesCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports